export const tvinnaStatusFromJobStatus = {
  full_time: 'full',
  part_time: 'part',
  per_diem: 'part',
  not_specified: 'part',
};

export const tvinnaStatusChoices = [
  { value: 'full', label: 'Fullt starf' },
  { value: 'part', label: 'Hlutastarf' },
  { value: 'freelance', label: 'Freelance' },
];
